var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m13.289 12.931 4.437 4.456a.926.926 0 0 1-.027 1.34.995.995 0 0 1-.68.265.992.992 0 0 1-.708-.291l-4.47-4.49a7.632 7.632 0 0 1-4.313 1.316C3.377 15.527 0 12.267 0 8.259 0 4.252 3.377.992 7.528.992c4.15 0 7.527 3.26 7.527 7.267a7.095 7.095 0 0 1-1.766 4.672Zm-.198-4.672c0-2.962-2.495-5.371-5.563-5.371-3.068 0-5.564 2.41-5.564 5.371 0 2.962 2.496 5.372 5.564 5.372 3.067 0 5.563-2.41 5.563-5.372Z",
  clipRule: "evenodd"
})));
export default SvgHome;